export default function () {
  // 日期格式化方法
  Date.prototype.parse = function (fmt) {
    var o = {
      'M+': this.getMonth() + 1,
      'd+': this.getDate(),
      'h+': this.getHours(),
      'm+': this.getMinutes(),
      's+': this.getSeconds(),
      'q+': Math.floor((this.getMonth() + 3) / 3),
      S: this.getMilliseconds(),
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
      }
    }
    return fmt;
  };

  // 获取北京时间
  Date.PekingTime = function () {
    var date = new Date();
    var localOffset = date.getTimezoneOffset() * 60000; // 本地时区偏移
    var beijingOffset = 8 * 3600 * 1000; // 北京时间偏移
    return date.getTime() + localOffset + beijingOffset;
  };
}

// 以下为旧代码

//js中Date的格式化方法
/**  对Date的扩展，将 Date 转化为指定格式的String
         月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
        年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
        例子：
    *   (new Date()).parse("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
    *   (new Date()).parse("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
    */
/*
export default function () {
    Date.prototype.parse=function(fmt) {
        var o = {
            "M+": this.getMonth() + 1, //月份
            "d+": this.getDate(), //日
            "h+": this.getHours(), //小时
            "m+": this.getMinutes(), //分
            "s+": this.getSeconds(), //秒
            "q+": Math.floor((this.getMonth() + 3) / 3), //季度
            "S": this.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    }

    //js前端获得北京时间
    Date.PekingTime = ()=>{
        var date = new Date();
        return new Date(
            date.getUTCFullYear(),
            date.getUTCMonth(),
            date.getUTCDate(),
            date.getUTCHours(),
            date.getUTCMinutes(),
            date.getUTCSeconds(),
            date.getUTCMilliseconds()
        ).getTime()+8*3600*1000;
    }
}
*/
